var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-header row justify-content-between",class:_vm.theme},[(
      _vm.blok.header_link && _vm.blok.header_link[0] && _vm.blok.header_link[0].component
    )?_c('div',{staticClass:"section-header__link col-12"},[_c(_vm._f("dashify")(_vm.blok.header_link[0].component),{tag:"component",attrs:{"blok":_vm.blok.header_link[0],"modifier-class":"icon icon--arrow"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }